import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { WIDGET_WALLS_DATA, WIDGET_WALL_UPDATE } from "../../../../../../actions/wallsAction";
import Swal from "sweetalert2";
import { toast } from 'react-toastify';
import { loadHomeNew } from "../../../../../../actions/dashboardActions";
import moment from "moment";
import { removeWall } from "../../../../../../actions/analyticsAction";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import { Link } from "react-router-dom";

function DropdownComponet({ setwallactiveStatus, userData, props,ownerId }) {

  const dispatch = useDispatch()
  const { clickToUpdateState, wallsData } = props;
  const { name, url, status, autoUpdate, profanity, id, collaboratorId, collaboratorRole } = props.wallsData;
  const [wallStatus, setWallStatus] = useState(status);
  const [autoUpdateWall, setAutoUpdateWall] = useState(autoUpdate);

  let collaboratorRole_3 = collaboratorId == ownerId ? collaboratorRole === 3 ? false : true : true;
  let collaboratorRole_2 = collaboratorId == ownerId ? collaboratorRole === 2 ? false : true : true;
 
  const toastId = useRef(null);
  const loading = (msg) => {
    if (!toast.isActive(toastId.current)) toastId.current = toast.loading(msg, {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    })
  };
  const success = (msg) => toast.update(toastId.current, {
    render: msg,
    type: "success",
    position: "bottom-right",
    autoClose: 2000,
    isLoading: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const errorMsg = (msg) => toast.update(toastId.current, {
    render: msg,
    type: "error",
    position: "bottom-right",
    autoClose: 2000,
    isLoading: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  useEffect(() => {
    const { wallsData } = props;
    setAutoUpdateWall(wallsData.autoUpdate === 0 ? 0 : 1)
  }, [props])

  const onAutoWallUpdate = (wallstatus, data) => { 
    loading("Please Wait...")
    setAutoUpdateWall(data)
    WIDGET_WALL_UPDATE({ name, url, autoUpdate: data, profanity: url, status: wallstatus, id, delete: 0 })
      .then((res) => {
        const { data } = res;
        success(`Auto update ${data.responseData.autoUpdate == 1 ? 'on' : 'off'} successfully.`)
        setTimeout(() => { toast.dismiss() }, 500);

      }).catch((error) => {
        const { data } = error.response;
        if (data.responseCode === 404) {
          errorMsg(data.message)
        }
      });;
  }


  const onActiveWall = (wallautoUpdate, Status) => {
    setWallStatus(Status)
    loading("Loading...")

    WIDGET_WALL_UPDATE({ name, url, autoUpdate: wallautoUpdate, profanity, status: Status, id, delete: 0 })
      .then((response) => {
        const { data } = response
        success(`Status ${data.responseData.status === 1 ? 'on' : 'off'} successfully.`)
        setwallactiveStatus(data.responseData.status)
        setTimeout(() => { toast.dismiss() }, 500);
      }).catch((error) => {
        const { data } = error.response;
        if (data.responseCode === 404) {
          errorMsg(data.message)
        }
      });
  }

  const onDeleteGalleryWall = (item) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        loading("Loading...")
        WIDGET_WALL_UPDATE({ name: item.name, url: item.url, profanity: item.url, status: item.status, autoUpdate: item.autoUpdate, id: item.id, deleted: 1 }).then((response) => {
        dispatch(removeWall(item.id))
         success(`Wall deleted successfully`);
         dispatch(window.location.href.includes('home') ? loadHomeNew(1,moment().subtract(30, 'days').startOf('day'),moment().endOf('day')) : WIDGET_WALLS_DATA())
        })
          .catch((error) => {
            // const { data } = error.response;
            // if (data.response_code === 404) { this.setState({ submitErrorMessage: data.message, apiRequest: false }) }
            // errorMsg(data.message)
          });
      }

      else if (result.dismiss === "cancel") { }

    });
  }


  return (
    <>
      <ul className="navi navi-hover">

        {collaboratorRole_3?

          <li style={{ cursor: 'pointer' }} className={`navi-item ${userData.user.plan_exceed == "2" ? 'd-none' : ''}`}>
            <Link onClick={clickToUpdateState({ profanity: profanity, modalShow: true, name: name, url: url, wall_id: id, autoUpdate: 1, rename_status: 1, callbackWall : 2  })} className="navi-link tooltips resetAction init popUp">
              <span className="navi-icon">
                <FontAwesomeIcon type={'regular'} icon={'pencil'} iconClass={'text-secondary fs-6'} />
              </span>
              <span className="navi-text ">Rename</span>
            </Link>
          </li> : null}
        {collaboratorRole_3 && collaboratorRole_2  ?

          <li style={{ cursor: 'pointer' }} className={`navi-item ${userData.user.plan_exceed == "2" ? 'd-none' : ''}`}>
            <a
              onClick={() => onDeleteGalleryWall(wallsData)}
              className="navi-link tooltips delete init"
            >
              <span className="navi-icon">
                <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'text-secondary fs-6'} />
              </span>
              <span className="navi-text">Delete</span>
            </a>
          </li>

          : null}

        {

          userData.user.plan_exceed == 1 ?
            <>
              {collaboratorRole_3 ?

                <li className="navi-separator my-2 opacity-70"></li> : null}
              <li className={`navi-item ${userData.user.plan_exceed == "2" ? 'd-none' : ''}`}>
                <div className="wall_toggle_action d-block ps-4 pe-4">
                  <div className="d-flex align-items-center justify-content-between py-2">
                    <span>Auto Update </span>
                    <span className="switch switch-xs lh-1">
                      <label>
                        <input
                          type="checkbox"
                          value="1"
                          className="onoffswitch-checkbox updateStatus init"
                          onChange={() => onAutoWallUpdate(wallStatus, autoUpdateWall == 1 ? 0 : 1) }
                          checked={autoUpdateWall == 1 ? true : false}
                        />
                        <span></span>
                      </label>
                    </span>
                  </div>
                </div>
              </li>
              <li className={`navi-item ${userData.user.plan_exceed == "2" ? 'd-none' : ''}`}>
                <div className="wall_toggle_action d-block ps-4 pe-4">
                  <div className="d-flex align-items-center justify-content-between py-2">
                    <span>Status  </span>
                    <span className="switch switch-xs lh-1">
                      <label>
                        <input
                          type="checkbox"
                          onChange={() => onActiveWall(autoUpdateWall, wallStatus == 1 ? 0 : 1)}
                          value="1"
                          className="onoffswitch-checkbox updateStatus init"
                          checked={wallStatus == 1 ? true : false}
                        />
                        <span></span>
                      </label>
                    </span>
                  </div>
                </div>
              </li> </> : null}
      </ul>
    </>
  );
}
export default DropdownComponet;
